
export const TextHelper = {
    removeHtml (text) {
        return text.replace(/(<([^>]+)>)/gi, "");
    },
    htmlDecode(input){
        const e = document.createElement('div');
        e.innerHTML = input.replace(/([&]nbsp[;])/g, ' ');
        return e.innerText;
    },
    slugify(text) {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')

        return text.toString().toLowerCase()
            .replace(/\s+/g, '-')
            .replace(p, c => b.charAt(a.indexOf(c)))
            .replace(/&/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '')
    }
}



// WEBPACK FOOTER //
// ./src/helpers/text.helper.js